// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1nySQ","selected":"Chip_selected__3mTcZ"};